export const categories = [
  { slug: "romance", name: "恋爱", icon: "ri-heart-line" },
  { slug: "fantasy", name: "奇幻", icon: "ri-magic-line" },
  { slug: "action", name: "动作", icon: "ri-flashlight-line" },
  { slug: "drama", name: "剧情", icon: "ri-emotion-line" },
  { slug: "comedy", name: "搞笑", icon: "ri-emotion-happy-line" },
  { slug: "thriller", name: "悬疑", icon: "ri-ghost-line" },
  { slug: "school", name: "校园", icon: "ri-building-line" },
  { slug: "bl", name: "BL", icon: "ri-user-heart-line" },
  { slug: "gl", name: "GL", icon: "ri-women-line" },
  { slug: "historical", name: "古风", icon: "ri-ancient-gate-line" },
];

export interface Comic {
  id: number;
  title: string;
  author: string;
  cover: string;
  rating: number;
  category: string;
  description: string;
  status: "连载" | "完结";
  views: number;
  chapters: number;
  updatedAt: string;
  tags: string[];
}

export const featuredComics: Comic[] = [
  {
    id: 1,
    title: "某天成为公主",
    author: "Spoon",
    cover: "https://readdy.ai/api/search-image?query=Beautiful%20Korean%20webtoon%20style%20cover%20art%20of%20a%20princess%20in%20elegant%20gown%20with%20long%20flowing%20hair%2C%20soft%20pastel%20colors%2C%20romantic%20atmosphere%2C%20watercolor%20texture%2C%20dreamy%20lighting%2C%20golden%20accents%2C%20royal%20palace%20background%20with%20cherry%20blossoms%2C%20manhwa%20art%20style&width=600&height=800&seq=comic-cover-01&orientation=portrait",
    rating: 4.9,
    category: "romance",
    description: "某天醒来发现自己变成了小说中的公主，为了不被父皇处死，她必须努力扮演好公主的角色。",
    status: "连载",
    views: 1520000,
    chapters: 156,
    updatedAt: "2026-08-05",
    tags: ["穿越", "宫廷", "恋爱", "成长"],
  },
  {
    id: 2,
    title: "全知读者视角",
    author: "sing N song",
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20art%20of%20a%20mysterious%20man%20in%20black%20coat%20holding%20a%20glowing%20book%2C%20apocalyptic%20background%20with%20ruins%2C%20dramatic%20lighting%2C%20dark%20atmospheric%20tones%2C%20manhwa%20style%20illustration%2C%20fantasy%20elements&width=600&height=800&seq=comic-cover-02&orientation=portrait",
    rating: 4.8,
    category: "fantasy",
    description: "唯一读完那部小说的人，在小说成为现实后，凭借对剧情的了解开启生存之旅。",
    status: "连载",
    views: 2380000,
    chapters: 203,
    updatedAt: "2026-08-04",
    tags: ["末世", "系统", "冒险", "悬疑"],
  },
  {
    id: 3,
    title: "我独自升级",
    author: "Chugong",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20of%20a%20powerful%20warrior%20with%20dark%20armor%20and%20glowing%20eyes%2C%20surrounded%20by%20shadow%20soldiers%2C%20epic%20battle%20scene%2C%20dark%20and%20intense%20atmosphere%2C%20dramatic%20composition%2C%20manhwa%20style%20illustration&width=600&height=800&seq=comic-cover-03&orientation=portrait",
    rating: 4.9,
    category: "action",
    description: "最弱的E级猎人，在一次生死关头获得了'系统'的力量，开始独自升级变强。",
    status: "完结",
    views: 5200000,
    chapters: 179,
    updatedAt: "2026-07-28",
    tags: ["系统", "升级", "热血", "战斗"],
  },
  {
    id: 4,
    title: "反派小姐的男主人公",
    author: "Gwon Gyeoeul",
    cover: "https://readdy.ai/api/search-image?query=Korean%20romance%20webtoon%20cover%20art%20of%20a%20beautiful%20woman%20in%20vintage%20dress%20with%20a%20handsome%20duke%2C%20regal%20palace%20garden%20background%2C%20soft%20romantic%20lighting%2C%20rose%20petals%20floating%2C%20manhwa%20style%2C%20warm%20golden%20tones&width=600&height=800&seq=comic-cover-04&orientation=portrait",
    rating: 4.7,
    category: "romance",
    description: "穿越成小说中的反派小姐，为了生存必须攻略男主人公的心。",
    status: "连载",
    views: 1890000,
    chapters: 132,
    updatedAt: "2026-08-03",
    tags: ["穿越", "恋爱", "反派", "宫廷"],
  },
  {
    id: 5,
    title: "入赘女婿",
    author: "Studio JBB",
    cover: "https://readdy.ai/api/search-image?query=Korean%20action%20manhwa%20cover%20of%20a%20mysterious%20man%20in%20modern%20suit%20with%20intense%20gaze%2C%20urban%20cityscape%20at%20night%2C%20neon%20lights%2C%20thriller%20vibe%2C%20manhwa%20illustration%20style%2C%20dark%20and%20moody%20atmosphere&width=600&height=800&seq=comic-cover-05&orientation=portrait",
    rating: 4.6,
    category: "drama",
    description: "入赘豪门的上门女婿，隐藏身份的他其实是令人闻风丧胆的地下皇帝。",
    status: "连载",
    views: 3100000,
    chapters: 98,
    updatedAt: "2026-08-05",
    tags: ["都市", "爽文", "逆袭", "动作"],
  },
];

export const latestComics: Comic[] = [
  {
    id: 6,
    title: "剑尊归来",
    author: "Cheongcho",
    cover: "https://readdy.ai/api/search-image?query=Korean%20martial%20arts%20manhwa%20cover%20art%2C%20swordsman%20with%20white%20hair%20and%20traditional%20robe%2C%20holding%20a%20glowing%20sword%2C%20mountain%20peak%20background%20with%20moon%2C%20elegant%20brushwork%20style%2C%20manhwa%20illustration%2C%20serene%20yet%20powerful&width=600&height=800&seq=comic-cover-06&orientation=portrait",
    rating: 4.8,
    category: "action",
    description: "天下第一剑归来了！曾经的武林至尊转世重生，这一世他要守护所爱之人。",
    status: "连载",
    views: 870000,
    chapters: 67,
    updatedAt: "2026-08-05",
    tags: ["武侠", "转世", "热血", "修仙"],
  },
  {
    id: 7,
    title: "我的野蛮王妃",
    author: "Park So-hee",
    cover: "https://readdy.ai/api/search-image?query=Korean%20romantic%20comedy%20manhwa%20cover%2C%20cheerful%20girl%20in%20school%20uniform%20laughing%2C%20cherry%20blossom%20background%2C%20bright%20and%20playful%20atmosphere%2C%20manhwa%20art%20style%2C%20pastel%20colors%2C%20youthful%20energy&width=600&height=800&seq=comic-cover-07&orientation=portrait",
    rating: 4.5,
    category: "comedy",
    description: "灰姑娘与王子协议结婚，从互相嫌弃到真心相爱的甜蜜故事。",
    status: "完结",
    views: 2900000,
    chapters: 220,
    updatedAt: "2026-08-04",
    tags: ["校园", "恋爱", "搞笑", "契约"],
  },
  {
    id: 8,
    title: "神医嫡女",
    author: "Yun Ji",
    cover: "https://readdy.ai/api/search-image?query=Korean%20historical%20manhwa%20cover%20art%20of%20a%20beautiful%20female%20doctor%20in%20traditional%20hanbok%2C%20holding%20acupuncture%20needles%2C%20ancient%20Korean%20palace%20background%2C%20elegant%20and%20mysterious%2C%20manhwa%20style%20illustration%2C%20warm%20amber%20tones&width=600&height=800&seq=comic-cover-08&orientation=portrait",
    rating: 4.7,
    category: "historical",
    description: "现代女医生穿越到古代，凭借一身医术在宫廷中立足并寻得真爱。",
    status: "连载",
    views: 1650000,
    chapters: 145,
    updatedAt: "2026-08-03",
    tags: ["穿越", "古风", "医术", "恋爱"],
  },
  {
    id: 9,
    title: "鬼怪",
    author: "Kim Eun-sook",
    cover: "https://readdy.ai/api/search-image?query=Korean%20fantasy%20manhwa%20cover%2C%20mysterious%20immortal%20being%20in%20long%20coat%20with%20ancient%20sword%2C%20autumn%20leaves%20falling%2C%20melancholic%20atmosphere%2C%20manhwa%20style%2C%20warm%20but%20sad%20tones%2C%20poetic%20composition&width=600&height=800&seq=comic-cover-09&orientation=portrait",
    rating: 4.9,
    category: "fantasy",
    description: "不死的鬼怪寻找能够结束他永恒生命的新娘，却意外陷入命运的爱恋。",
    status: "完结",
    views: 4800000,
    chapters: 188,
    updatedAt: "2026-08-01",
    tags: ["奇幻", "恋爱", "命运", "神怪"],
  },
  {
    id: 10,
    title: "替身女王",
    author: "Lee Hyeon-sook",
    cover: "https://readdy.ai/api/search-image?query=Korean%20thriller%20manhwa%20cover%20art%20of%20a%20woman%20with%20cold%20expression%20in%20black%20dress%2C%20shadowy%20mansion%20background%2C%20mysterious%20and%20suspenseful%2C%20manhwa%20illustration%20style%2C%20dark%20sophisticated%20tones&width=600&height=800&seq=comic-cover-10&orientation=portrait",
    rating: 4.6,
    category: "thriller",
    description: "为了复仇她成为财阀千金的替身，却发现了这个家族隐藏的惊天秘密。",
    status: "连载",
    views: 1250000,
    chapters: 89,
    updatedAt: "2026-08-05",
    tags: ["悬疑", "复仇", "豪门", "替身"],
  },
  {
    id: 11,
    title: "蓝色大海的传说",
    author: "Park Ji-eun",
    cover: "https://readdy.ai/api/search-image?query=Korean%20fantasy%20romance%20manhwa%20cover%20of%20a%20beautiful%20mermaid%20in%20ocean%20with%20sparkling%20water%2C%20moonlit%20sea%2C%20ethereal%20atmosphere%2C%20manhwa%20style%2C%20blue%20and%20silver%20color%20palette%2C%20dreamy%20composition&width=600&height=800&seq=comic-cover-11&orientation=portrait",
    rating: 4.7,
    category: "fantasy",
    description: "人鱼与天才骗子的跨种族爱恋，从古代延续到现代的宿命之约。",
    status: "完结",
    views: 3500000,
    chapters: 200,
    updatedAt: "2026-07-30",
    tags: ["奇幻", "恋爱", "人鱼", "转世"],
  },
  {
    id: 12,
    title: "金秘书为何那样",
    author: "Jung Kyung-yoon",
    cover: "https://readdy.ai/api/search-image?query=Korean%20romantic%20comedy%20office%20manhwa%20cover%2C%20confident%20female%20secretary%20in%20professional%20attire%2C%20modern%20office%20background%2C%20bright%20and%20cheerful%20vibe%2C%20manhwa%20art%20style%2C%20clean%20and%20crisp%20colors&width=600&height=800&seq=comic-cover-12&orientation=portrait",
    rating: 4.5,
    category: "romance",
    description: "完美秘书突然提出辞职，自恋副会长才发现自己早已离不开她。",
    status: "完结",
    views: 2700000,
    chapters: 165,
    updatedAt: "2026-07-25",
    tags: ["职场", "恋爱", "搞笑", "甜宠"],
  },
  {
    id: 13,
    title: "校园怪谈",
    author: "Oh Seong-dae",
    cover: "https://readdy.ai/api/search-image?query=Korean%20horror%20school%20manhwa%20cover%2C%20students%20in%20dark%20school%20corridor%20with%20eerie%20shadows%2C%20mysterious%20supernatural%20atmosphere%2C%20manhwa%20style%20illustration%2C%20cold%20blue%20tones%2C%20suspenseful%20composition&width=600&height=800&seq=comic-cover-13&orientation=portrait",
    rating: 4.4,
    category: "thriller",
    description: "转学到一所神秘的学校后，接连发生的诡异事件让主角陷入恐怖漩涡。",
    status: "连载",
    views: 980000,
    chapters: 78,
    updatedAt: "2026-08-04",
    tags: ["悬疑", "校园", "恐怖", "超自然"],
  },
  {
    id: 14,
    title: "BL童话",
    author: "Jung Seo",
    cover: "https://readdy.ai/api/search-image?query=Korean%20BL%20romance%20manhwa%20cover%20art%20of%20two%20handsome%20men%20standing%20back%20to%20back%2C%20soft%20romantic%20lighting%2C%20flower%20petals%2C%20manhwa%20style%2C%20warm%20and%20tender%20atmosphere%2C%20delicate%20illustration&width=600&height=800&seq=comic-cover-14&orientation=portrait",
    rating: 4.6,
    category: "bl",
    description: "两个性格截然不同的男人在意外同居后，逐渐萌生了超越友情的感情。",
    status: "连载",
    views: 1120000,
    chapters: 115,
    updatedAt: "2026-08-05",
    tags: ["BL", "恋爱", "同居", "甜宠"],
  },
  {
    id: 15,
    title: "橘子果酱",
    author: "Seok Woo",
    cover: "https://readdy.ai/api/search-image?query=Korean%20school%20romance%20manhwa%20cover%20of%20a%20girl%20in%20school%20uniform%20under%20sunlight%2C%20orange%20warm%20tones%2C%20music%20notes%20floating%2C%20manhwa%20style%2C%20youthful%20and%20refreshing%20atmosphere%2C%20clean%20composition&width=600&height=800&seq=comic-cover-15&orientation=portrait",
    rating: 4.4,
    category: "school",
    description: "吸血鬼少女隐藏身份在人类学校生活，却爱上了讨厌吸血鬼的校草。",
    status: "完结",
    views: 2100000,
    chapters: 198,
    updatedAt: "2026-07-22",
    tags: ["校园", "吸血鬼", "恋爱", "奇幻"],
  },
];

export const rankingComics: Comic[] = [
  {
    id: 1,
    title: "某天成为公主",
    author: "Spoon",
    cover: "https://readdy.ai/api/search-image?query=Beautiful%20Korean%20webtoon%20style%20cover%20art%20of%20a%20princess%20in%20elegant%20gown%20with%20long%20flowing%20hair%2C%20soft%20pastel%20colors%2C%20romantic%20atmosphere%2C%20watercolor%20texture%2C%20dreamy%20lighting%2C%20golden%20accents%2C%20royal%20palace%20background%20with%20cherry%20blossoms%2C%20manhwa%20art%20style&width=600&height=800&seq=comic-cover-01&orientation=portrait",
    rating: 4.9,
    category: "romance",
    description: "某天醒来发现自己变成了小说中的公主。",
    status: "连载",
    views: 1520000,
    chapters: 156,
    updatedAt: "2026-08-05",
    tags: ["穿越", "宫廷", "恋爱"],
  },
  {
    id: 3,
    title: "我独自升级",
    author: "Chugong",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20of%20a%20powerful%20warrior%20with%20dark%20armor%20and%20glowing%20eyes%2C%20surrounded%20by%20shadow%20soldiers%2C%20epic%20battle%20scene%2C%20dark%20and%20intense%20atmosphere%2C%20dramatic%20composition%2C%20manhwa%20style%20illustration&width=600&height=800&seq=comic-cover-03&orientation=portrait",
    rating: 4.9,
    category: "action",
    description: "最弱的E级猎人获得系统力量开始独自升级。",
    status: "完结",
    views: 5200000,
    chapters: 179,
    updatedAt: "2026-07-28",
    tags: ["系统", "升级", "热血"],
  },
  {
    id: 2,
    title: "全知读者视角",
    author: "sing N song",
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20art%20of%20a%20mysterious%20man%20in%20black%20coat%20holding%20a%20glowing%20book%2C%20apocalyptic%20background%20with%20ruins%2C%20dramatic%20lighting%2C%20dark%20atmospheric%20tones%2C%20manhwa%20style%20illustration%2C%20fantasy%20elements&width=600&height=800&seq=comic-cover-02&orientation=portrait",
    rating: 4.8,
    category: "fantasy",
    description: "唯一读完那部小说的人，在小说成为现实后开启生存之旅。",
    status: "连载",
    views: 2380000,
    chapters: 203,
    updatedAt: "2026-08-04",
    tags: ["末世", "系统", "冒险"],
  },
  {
    id: 9,
    title: "鬼怪",
    author: "Kim Eun-sook",
    cover: "https://readdy.ai/api/search-image?query=Korean%20fantasy%20manhwa%20cover%2C%20mysterious%20immortal%20being%20in%20long%20coat%20with%20ancient%20sword%2C%20autumn%20leaves%20falling%2C%20melancholic%20atmosphere%2C%20manhwa%20style%2C%20warm%20but%20sad%20tones%2C%20poetic%20composition&width=600&height=800&seq=comic-cover-09&orientation=portrait",
    rating: 4.9,
    category: "fantasy",
    description: "不死的鬼怪寻找能结束他永恒生命的新娘。",
    status: "完结",
    views: 4800000,
    chapters: 188,
    updatedAt: "2026-08-01",
    tags: ["奇幻", "恋爱", "命运"],
  },
  {
    id: 6,
    title: "剑尊归来",
    author: "Cheongcho",
    cover: "https://readdy.ai/api/search-image?query=Korean%20martial%20arts%20manhwa%20cover%20art%2C%20swordsman%20with%20white%20hair%20and%20traditional%20robe%2C%20holding%20a%20glowing%20sword%2C%20mountain%20peak%20background%20with%20moon%2C%20elegant%20brushwork%20style%2C%20manhwa%20illustration%2C%20serene%20yet%20powerful&width=600&height=800&seq=comic-cover-06&orientation=portrait",
    rating: 4.8,
    category: "action",
    description: "天下第一剑归来！曾经的武林至尊转世重生。",
    status: "连载",
    views: 870000,
    chapters: 67,
    updatedAt: "2026-08-05",
    tags: ["武侠", "转世", "热血"],
  },
  {
    id: 5,
    title: "入赘女婿",
    author: "Studio JBB",
    cover: "https://readdy.ai/api/search-image?query=Korean%20action%20manhwa%20cover%20of%20a%20mysterious%20man%20in%20modern%20suit%20with%20intense%20gaze%2C%20urban%20cityscape%20at%20night%2C%20neon%20lights%2C%20thriller%20vibe%2C%20manhwa%20illustration%20style%2C%20dark%20and%20moody%20atmosphere&width=600&height=800&seq=comic-cover-05&orientation=portrait",
    rating: 4.6,
    category: "drama",
    description: "入赘豪门的上门女婿隐藏着地下皇帝的身份。",
    status: "连载",
    views: 3100000,
    chapters: 98,
    updatedAt: "2026-08-05",
    tags: ["都市", "爽文", "逆袭"],
  },
  {
    id: 8,
    title: "神医嫡女",
    author: "Yun Ji",
    cover: "https://readdy.ai/api/search-image?query=Korean%20historical%20manhwa%20cover%20art%20of%20a%20beautiful%20female%20doctor%20in%20traditional%20hanbok%2C%20holding%20acupuncture%20needles%2C%20ancient%20Korean%20palace%20background%2C%20elegant%20and%20mysterious%2C%20manhwa%20style%20illustration%2C%20warm%20amber%20tones&width=600&height=800&seq=comic-cover-08&orientation=portrait",
    rating: 4.7,
    category: "historical",
    description: "现代女医生穿越到古代凭借医术立足宫廷。",
    status: "连载",
    views: 1650000,
    chapters: 145,
    updatedAt: "2026-08-03",
    tags: ["穿越", "古风", "医术"],
  },
  {
    id: 11,
    title: "蓝色大海的传说",
    author: "Park Ji-eun",
    cover: "https://readdy.ai/api/search-image?query=Korean%20fantasy%20romance%20manhwa%20cover%20of%20a%20beautiful%20mermaid%20in%20ocean%20with%20sparkling%20water%2C%20moonlit%20sea%2C%20ethereal%20atmosphere%2C%20manhwa%20style%2C%20blue%20and%20silver%20color%20palette%2C%20dreamy%20composition&width=600&height=800&seq=comic-cover-11&orientation=portrait",
    rating: 4.7,
    category: "fantasy",
    description: "人鱼与天才骗子的跨种族爱恋从古代到现代。",
    status: "完结",
    views: 3500000,
    chapters: 200,
    updatedAt: "2026-07-30",
    tags: ["奇幻", "恋爱", "人鱼"],
  },
  {
    id: 4,
    title: "反派小姐的男主人公",
    author: "Gwon Gyeoeul",
    cover: "https://readdy.ai/api/search-image?query=Korean%20romance%20webtoon%20cover%20art%20of%20a%20beautiful%20woman%20in%20vintage%20dress%20with%20a%20handsome%20duke%2C%20regal%20palace%20garden%20background%2C%20soft%20romantic%20lighting%2C%20rose%20petals%20floating%2C%20manhwa%20style%2C%20warm%20golden%20tones&width=600&height=800&seq=comic-cover-04&orientation=portrait",
    rating: 4.7,
    category: "romance",
    description: "穿越成反派小姐必须攻略男主人公的心。",
    status: "连载",
    views: 1890000,
    chapters: 132,
    updatedAt: "2026-08-03",
    tags: ["穿越", "恋爱", "反派"],
  },
  {
    id: 10,
    title: "替身女王",
    author: "Lee Hyeon-sook",
    cover: "https://readdy.ai/api/search-image?query=Korean%20thriller%20manhwa%20cover%20art%20of%20a%20woman%20with%20cold%20expression%20in%20black%20dress%2C%20shadowy%20mansion%20background%2C%20mysterious%20and%20suspenseful%2C%20manhwa%20illustration%20style%2C%20dark%20sophisticated%20tones&width=600&height=800&seq=comic-cover-10&orientation=portrait",
    rating: 4.6,
    category: "thriller",
    description: "为复仇成为财阀千金替身发现惊天秘密。",
    status: "连载",
    views: 1250000,
    chapters: 89,
    updatedAt: "2026-08-05",
    tags: ["悬疑", "复仇", "豪门"],
  },
];

export const allComics = [...featuredComics, ...latestComics];

export const getComicsByCategory = (slug: string): Comic[] => {
  return allComics.filter((c) => c.category === slug);
};

export const getComicById = (id: number): Comic | undefined => {
  return allComics.find((c) => c.id === id);
};

export const getRelatedComics = (comic: Comic, count: number = 6): Comic[] => {
  return allComics
    .filter((c) => c.id !== comic.id && c.category === comic.category)
    .slice(0, count);
};

export interface Chapter {
  id: number;
  comicId: number;
  title: string;
  number: number;
  createdAt: string;
}

export const getChaptersByComicId = (comicId: number): Chapter[] => {
  const baseChapters: Chapter[] = [];
  const totalChapters = comicId === 1 ? 156 : comicId === 2 ? 203 : comicId === 3 ? 179 : 89;
  for (let i = totalChapters; i >= 1; i--) {
    baseChapters.push({
      id: comicId * 10000 + i,
      comicId,
      title: `第${i}话`,
      number: i,
      createdAt: `2026-0${(i % 9) + 1}-${String((i % 28) + 1).padStart(2, "0")}`,
    });
  }
  return baseChapters;
};